import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const NetAdminMenu = () => (
	<a href='#/netadmin'><Trans>Network Configuration</Trans></a>
);
